/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation";

// Splash Screen
const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 2000
};

// Summary And Greeting Section
const illustration = {
  animated: true
};

const greeting = {
  username: "Jindong Fu",
  title: "Hi, I'm Jindong Fu",
  subTitle: emoji(
    "🤖 AI Native Practitioner · 📱 Mobile Engineer · 🎨 Graphics — Software Engineer @ Microsoft. 拥抱 AI Native，探索 AI 能力边界，把大模型变成真正可交付的能力。"
  ),
  resumeLink: "", // 有 PDF 再填
  displayGreeting: true
};

// Social Media Links
const socialMediaLinks = {
  github: "https://github.com/SymbolStar",
  linkedin: "",
  gmail: "891694368@qq.com",
  // gitlab / facebook / medium / stackoverflow — leave empty
  display: true
};

// Skills Section
const skillsSection = {
  title: "What I do",
  subTitle:
    "AI AGENT TINKERER · MOBILE ENGINEER · GRAPHICS — CRAFTING NATIVE MOBILE EXPERIENCES AND EXPLORING THE INTERSECTION OF GRAPHICS, AI AGENTS, AND DEVELOPER TOOLING.",
  skills: [
    emoji(
      "⚡ 围绕 AI Agent 生态构建工具与产品 —— 多智能体协作、Agent 任务编排、Agent 友好的数据/信号服务"
    ),
    emoji(
      "⚡ 大规模 iOS App 稳定性建设 —— crash / hang / storage / sign-in quality，服务百万级 Copilot 用户"
    ),
    emoji(
      "⚡ iOS 3D 渲染 & Metal —— 虚拟人像实时语音交互（Copilot Lumi Model）"
    ),
    emoji(
      "⚡ 智能硬件与嵌入式 —— Android 智能硬件、儿童机器人（Arduino）、共享健身仓设备控制"
    )
  ],

  softwareSkills: [
    {skillName: "swift", fontAwesomeClassname: "fab fa-swift"},
    {skillName: "apple", fontAwesomeClassname: "fab fa-apple"},
    {skillName: "android", fontAwesomeClassname: "fab fa-android"},
    {skillName: "java", fontAwesomeClassname: "fab fa-java"},
    {skillName: "JavaScript", fontAwesomeClassname: "fab fa-js"},
    {skillName: "TypeScript", fontAwesomeClassname: "fab fa-js-square"},
    {skillName: "reactjs", fontAwesomeClassname: "fab fa-react"},
    {skillName: "nodejs", fontAwesomeClassname: "fab fa-node"},
    {skillName: "python", fontAwesomeClassname: "fab fa-python"},
    {skillName: "html-5", fontAwesomeClassname: "fab fa-html5"},
    {skillName: "css3", fontAwesomeClassname: "fab fa-css3-alt"},
    {skillName: "git", fontAwesomeClassname: "fab fa-git-alt"},
    {skillName: "github", fontAwesomeClassname: "fab fa-github"},
    {skillName: "docker", fontAwesomeClassname: "fab fa-docker"},
    {skillName: "database", fontAwesomeClassname: "fas fa-database"},
    {skillName: "microchip", fontAwesomeClassname: "fas fa-microchip"},
    {skillName: "robot", fontAwesomeClassname: "fas fa-robot"}
  ],
  display: true
};

// Education Section — 你没提供，先关掉
const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "金陵科技学院",
      logo: require("./assets/images/jitLogo.png"),
      subHeader: "本科 · 电气工程及其自动化",
      duration: "Jinling Institute of Technology",
      desc: "",
      descBullets: []
    }
  ]
};

// Proficiency — hidden
const techStack = {
  viewSkillBars: false,
  experience: [],
  displayCodersrank: false
};

// Work experience section
const workExperiences = {
  display: true,
  experience: [
    {
      role: "Software Engineer",
      company: "Microsoft",
      companylogo: require("./assets/images/microsoftLogo.png"),
      date: "Feb 2021 – Present",
      desc:
        "Bing / Copilot Mobile — 参与 Copilot 移动端从 0 到百万级用户的完整历程，从基础质量到 AI 交互体验。",
      descBullets: [
        "🤖 当前：Office Copilot Agentic Harness — Office 场景下的 Copilot Agent 运行框架",
        "🎨 Copilot iOS · 3D 渲染 Lumi Model — 虚拟人像与用户实时语音交互，改善 voice 沟通体验",
        "🛡️ Bing / Copilot App Foundation 核心成员 — crash rate / App hang rate / storage / sign-in quality"
      ]
    },
    {
      role: "Co-founder / Android & Hardware Lead",
      company: "也跑信息技术有限公司",
      companylogo: require("./assets/images/yepaoLogo.png"),
      date: "Startup — 共享健身仓",
      desc:
        "初创共享健身仓项目：负责 Android 应用端（用户端 + 管理端），以及健身仓硬件设备控制系统 —— 门锁、灯光、传感器、支付联动。从 0 到 1 落地运营站点。"
    },
    {
      role: "Mobile & Embedded Developer",
      company: "苏州云世界网络技术有限公司",
      companylogo: require("./assets/images/yunshijieLogo.png"),
      date: "儿童机器人",
      desc:
        "软硬件一体的儿童教育机器人产品：Android 应用（教育 / 交互 / 内容分发） + Arduino 硬件层（传感器、电机、交互逻辑）。"
    }
  ]
};

// Open Source (GitHub pinned)
const openSource = {
  showGithubProfile: "true",
  display: true
};

// Big Projects
const bigProjects = {
  title: "Open Source Projects",
  subtitle:
    "选自 github.com/SymbolStar (54 REPOS) · 围绕 AI AGENT 生态 · 真实下载量数据",
  projects: [
    {
      projectName: "✉️ gmail-mcp",
      projectDesc:
        "Gmail MCP (Model Context Protocol) server — 把 Gmail 作为头等工具暴露给 AI Agent。\n\n📥 npm: 1.4k 下载/月 · 6.2k 下载/年",
      footerLink: [
        {name: "GitHub", url: "https://github.com/SymbolStar/gmail-mcp"},
        {name: "npm", url: "https://www.npmjs.com/package/gmail-mcp"}
      ]
    },
    {
      projectName: "🔨 OpenForge",
      projectDesc:
        "Multi-agent task tracker for OpenClaw. Threads are tasks; @ assigns the next agent. Slack-style three-pane UI, JSONL event log, zero dependencies.\n\n⭐ 3 stars",
      footerLink: [
        {name: "GitHub", url: "https://github.com/SymbolStar/OpenForge"}
      ]
    },
    {
      projectName: "🐦 magpie",
      projectDesc:
        "A 股监控守护进程 — watchlist / 价格与资金流告警 / Agent-friendly HTTP API。好消息坏消息都报 — 像喜鹊一样。\n\n📥 npm: 235 下载/年 · ⭐ 3 stars",
      footerLink: [
        {name: "GitHub", url: "https://github.com/SymbolStar/magpie"},
        {name: "npm", url: "https://www.npmjs.com/package/magpie"}
      ]
    },
    {
      projectName: "🛡️ shipcheck",
      projectDesc:
        "发布前 PII / 密钥泄露检查 — 适用 npm 包、OpenClaw skills、本地 repo。Ship safer.\n\n📥 npm: 275 下载/年",
      footerLink: [
        {name: "GitHub", url: "https://github.com/SymbolStar/shipcheck"},
        {name: "npm", url: "https://www.npmjs.com/package/shipcheck"}
      ]
    },
    {
      projectName: "🔔 echo-cue",
      projectDesc:
        "OpenClaw Control UI 回复完成时的网页音提醒 — 悬浮选择器 + 11 种铃声预设。\n\n📈 已发布到 ClawHub · ⭐ 1 star",
      footerLink: [
        {name: "GitHub", url: "https://github.com/SymbolStar/echoCue"},
        {name: "ClawHub", url: "https://clawhub.ai/skill/echo-cue"}
      ]
    },
    {
      projectName: "🦞 OpenClaw (Contributor)",
      projectDesc:
        "Personal AI assistant, any OS / any platform. Contributor to the core open-source project.\n\n🔀 4 merged PRs",
      footerLink: [
        {name: "GitHub", url: "https://github.com/openclaw/openclaw"}
      ]
    }
  ],
  display: true
};

const achievementSection = {
  title: emoji("Achievements 🏆"),
  subtitle: "",
  achievementsCards: [],
  display: false
};

const blogSection = {
  title: "Blogs",
  subtitle: "",
  displayMediumBlogs: "false",
  blogs: [],
  display: false
};

const talkSection = {
  title: "TALKS",
  subtitle: "",
  talks: [],
  display: false
};

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "",
  podcast: [],
  display: false
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  display: false // 有 PDF 再打开
};

const contactInfo = {
  title: emoji("Get in Touch ☎️"),
  subtitle:
    "想聊项目，或只是想打个招呼？GitHub 踢我或邮件。想及时了解 AI 最新动态，关注 Agent team 的微信公众号《小符在干嘛》。如果你对 3D 打印感兴趣，也可以一起交流哈～",
  number: "",
  email_address: "891694368@qq.com",
  wechat_official: "小符在干嘛"
};

// Twitter — hidden
const twitterDetails = {
  userName: "",
  display: false
};

const isHireable = false;

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
